module.exports = __webpack_public_path__ + "static/media/feature.1696afcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HearthHouse/feature.jpg
// module id = 202
// module chunks = 0